import React from 'react';

import axios from '../../../../services/MyAxios';
import { API_CASINO_DASHBOARD_GGR_MARGIN } from '../../Helpers/CrmApiUrls';
import DoughnutBlock from '../Elements/DoughnutBlock';

export default function GgrMargin() {
    const axiosRequestCallback = (formattedStartDate: string, formattedEndDate: string) => {
        return axios.get(API_CASINO_DASHBOARD_GGR_MARGIN, {
            params: {
                start: formattedStartDate,
                end: formattedEndDate,
            },
        });
    };

    return (
        <DoughnutBlock
            title="GGR Margin change"
            questionMarkText="Formula: GGR / Sum of bets"
            axiosRequestCallback={axiosRequestCallback}
            unit="percentage"
        />
    );
}
